import { Refresh } from '~/components/refresh'
import { DISPLAY_NAME, useSwitchContext } from '../../switch'
import type { SwitchScopedProps } from '../../switch.types'

type SwitchRefreshProps = {}

export const SwitchRefresh = (props: SwitchRefreshProps) => {
  const { __scopeSwitch } = props as SwitchScopedProps<SwitchRefreshProps>

  const { disabled, loading } = useSwitchContext(DISPLAY_NAME, __scopeSwitch)

  const isShowLoading = loading && !disabled
  return (
    <>
      {isShowLoading && (
        <div data-testid="switch-refresh">
          <Refresh color="neutral" />
        </div>
      )}
    </>
  )
}
